import { useEffect } from 'react';

// Единственная точка, где React ставит <link rel="canonical">.
//
// Серверный SEO-блок (frontend/server.js) уже кладёт canonical в отданный
// index.html. react-helmet-async чужие теги не заменяет, а дописывает свой —
// поэтому на всех страницах, где canonical ставился через Helmet
// (components/SEO.jsx, components/CanonicalRf.jsx), в head оказывалось ДВА
// тега. Здесь тег правится нативно: существующий переписывается на месте,
// лишние снимаются — canonical на странице всегда ровно один.
export function setCanonical(href) {
  if (typeof document === 'undefined' || !href) return;
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  if (link.getAttribute('href') !== href) link.setAttribute('href', href);
  document.head.querySelectorAll('link[rel="canonical"]').forEach((el) => {
    if (el !== link) el.remove();
  });
}

export function useCanonical(href) {
  useEffect(() => {
    setCanonical(href);
  }, [href]);
}

// og:url — так же, как canonical: серверный HTML уже несёт
// <meta property="og:url">, а Helmet дописывал второй (на лунных страницах
// обоих сайтов после загрузки в head было два og:url). Существующий тег
// переписывается на месте, лишние снимаются.
export function setOgUrl(content) {
  if (typeof document === 'undefined' || !content) return;
  let meta = document.head.querySelector('meta[property="og:url"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('property', 'og:url');
    document.head.appendChild(meta);
  }
  if (meta.getAttribute('content') !== content) meta.setAttribute('content', content);
  document.head.querySelectorAll('meta[property="og:url"]').forEach((el) => {
    if (el !== meta) el.remove();
  });
}

export function useOgUrl(content) {
  useEffect(() => {
    setOgUrl(content);
  }, [content]);
}

/**
 * <meta name="…"> — тем же способом, что canonical и og:url: серверный тег
 * правится на месте, второй не появляется. Нужен страницам, которым сервер
 * уже отдал description и robots (SEO с nativeMeta).
 */
export function setMetaByName(name, content) {
  if (typeof document === 'undefined' || !name || content === undefined || content === null) return;
  let meta = document.head.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }
  if (meta.getAttribute('content') !== content) meta.setAttribute('content', content);
  document.head.querySelectorAll(`meta[name="${name}"]`).forEach((el) => {
    if (el !== meta) el.remove();
  });
}

export function useMetaByName(name, content) {
  useEffect(() => {
    setMetaByName(name, content);
  }, [name, content]);
}
